import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import LibraryWorkflowsGrid from './LibraryWorkflowsGrid';

const LibraryWorkflowsGridBridge = react2angular(LibraryWorkflowsGrid, []);

export default LibraryWorkflowsGridBridge;
